import { ModalTemplateWrapper } from '../ModalTemplateWrapper/ModalTemplateWrapper.js';
import { type CommonTemplateProps } from '../types.js';
import { MoneyEmoji } from '@contra/icons/emojis';

type ClientCreditIssuanceModalProps = CommonTemplateProps;

export const ClientCreditIssuanceModal = ({
  closeModal,
  isOpen,
}: ClientCreditIssuanceModalProps) => {
  const handleClose = () => {
    closeModal();
  };

  return (
    <ModalTemplateWrapper
      ariaLabel="Contra hiring credits"
      ctaOptions={{
        primaryCTA: {
          handleOnClick: handleClose,
          isLoading: false,
          label: 'Sounds good!',
        },
      }}
      desktopModalSize="md"
      headerText={
        <>
          <MoneyEmoji /> Contra hiring credits
        </>
      }
      isOpen={isOpen}
      onClose={handleClose}
      subheaderText="Contra hiring credits will be applied to your next payment of $500 or more. Hiring credits can be applied to the purchase of a service, paying an invoice or making a deposit for a project."
    />
  );
};
